/* eslint-disable no-console */
// NOTICE: KAPTION-INTEGRATION
// Kaption Feature Flags API client - Separate from Chatwoot's built-in feature flags
//
// This module provides HTTP API integration for fetching Kaption feature flags
// from the external service at flags.kaptionai.com
//

import axios from 'axios';
import { KAPTION_FEATURE_FLAGS_CONFIG } from '../config/kaptionFeatureFlags';

const kaptionFlagsAPI = axios.create({
  timeout: KAPTION_FEATURE_FLAGS_CONFIG.timeout,
});

export default {
  fetchFlags({ accountId, userId, platform = 'web' }) {
    const params = {
      platform,
      userId: userId?.toString(),
      install: KAPTION_FEATURE_FLAGS_CONFIG.installId,
      accountId: accountId?.toString(),
      environment: import.meta.env.MODE || 'production',
    };

    // Remove undefined/null params
    Object.keys(params).forEach(key => {
      if (params[key] === undefined || params[key] === null) {
        delete params[key];
      }
    });

    return kaptionFlagsAPI.get(KAPTION_FEATURE_FLAGS_CONFIG.apiUrl, { params });
  },
};
